import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type SliceMediaState = {
  selectedParentIdHierarchy: string[];
};

const initialState: SliceMediaState = {
  selectedParentIdHierarchy: [],
};

const slice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setSelectedParentIdHierarchy: (draft, action: PayloadAction<string[]>) => {
      draft.selectedParentIdHierarchy = action.payload;
    },
  },
});

export const { setSelectedParentIdHierarchy } = slice.actions;

export const reducerMedia = slice.reducer;
